var _rect, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWorkspace(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 8,
    fill: "#1A3F5E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.0742 22.7586H41.6548V20.0862C41.6548 19.1379 40.8709 15 39.9129 15C38.9548 15 38.1709 19.1379 38.1709 20.0862V22.7586H20.7516C19.2709 22.7586 18.1387 23.8793 18.1387 25.2586C18.1387 26.6379 19.2709 27.7586 20.7516 27.7586C22.2322 27.7586 23.3645 26.6379 23.3645 25.2586C23.3645 25.0862 30.7677 28.5345 38.0838 28.7069V56.6379C33.9903 56.8103 30.8548 58.2759 30.8548 59.3966C30.8548 59.569 30.9419 59.8276 31.1161 60H27.8064C27.1096 60 26.5871 60.5172 26.5871 61.1207V63.8793C26.5871 64.4828 27.1096 65 27.8064 65H31.3774C32.0742 65 32.5967 64.4828 32.5967 63.8793V63.2759H46.8806V63.8793C46.8806 64.4828 47.4032 65 48.1 65H51.6709C52.3677 65 52.8903 64.4828 52.8903 63.8793V61.1207C52.8903 60.5172 52.3677 60 51.6709 60H48.3612C48.5354 59.8276 48.6225 59.6552 48.6225 59.3966C48.6225 58.2759 45.4871 56.8103 41.3935 56.6379V28.7069C48.7967 28.6207 56.1129 25.1724 56.1129 25.2586C56.1129 26.6379 57.2451 27.7586 58.7258 27.7586C60.2064 27.7586 61.3387 26.6379 61.3387 25.2586C61.6871 23.8793 60.5548 22.7586 59.0742 22.7586Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0872 50.3448L20.8388 27.8448L28.6775 51.1207",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3226 51.2069L59.0742 27.8448L67.0001 51.9828",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6774 50.6897C28.6774 52.3276 25.1935 53.7931 20.8387 53.7931C16.4839 53.7931 13 52.3276 13 50.6897C13 49.0517 28.6774 49.0517 28.6774 50.6897Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9129 51.5517C66.9129 53.1897 63.429 54.6552 59.0742 54.6552C54.7193 54.6552 51.2355 53.1897 51.2355 51.5517C51.3226 49.9138 66.9129 49.9138 66.9129 51.5517Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.918748c800204e4210c556b1636742a8.svg";
export { ForwardRef as ReactComponent };